import { useState, useEffect, useRef } from "react";
import { Divider, Group, TextInput, Button, Paper, Text, Stack, Table, Select, Textarea, Title } from "@mantine/core";
import { Card, message, Flex, Spin, Alert } from "antd";
import { useAuthContext } from "../../Hooks/UseAuthContext";
import { useReactToPrint } from "react-to-print";




const Servicespricecost = [
    {
        index: 0,
        service_name: "Payout",
        One_time_implementation_charge: "50000"
    },
    {
        index: 1,
        service_name: "BBPS",
        One_time_implementation_charge: "10000"
    },
    {
        index: 2,
        service_name: "Mobile_Recharge",
        One_time_implementation_charge: "5000"
    },
    {
        index: 3,
        service_name: "Payin_UPI",
        One_time_implementation_charge: "50000"
    },
    {
        index: 4,
        service_name: "Aeps",
        One_time_implementation_charge: "10000"
    },
    {
        index: 5,
        service_name: "DMT",
        One_time_implementation_charge: "10000"
    },
    {
        index: 6,
        service_name: "Payment_Gateway_PG",
        One_time_implementation_charge: "80000"
    },
    {
        index: 7,
        service_name: "Bank_Verification",
        One_time_implementation_charge: "6000"
    },

]




const Payoutcommercial = ({ rectification = false, stepData, submissionDetails, onSuccess }) => {
    const { user } = useAuthContext();
    const [submitloading, setSubmitloading] = useState(false);
    const [companyProfile, setCompanyProfile] = useState(null);
    const [compliancedetails, setCompliancedetails] = useState(null);
    const [banksdetails, setbanksdetails] = useState(null);
    const [merchantduedeligencedetails, setmerchantduedeligencedetails] = useState(null);
    const [boardresolution, setboardresolution] = useState(null);
    const [merchantcriminalundertaking, setmerchantcriminalundertaking] = useState(null);
    //const [undertakingDate, setUndertakingDate] = useState("");
    const [commercialDate, setCommercialDate] = useState("");
    // const [implementationCharge, setImplementationCharge] = useState("");
    const [payoutUseCase, setPayoutUseCase] = useState("");
    const [chargebackAcceptance, setChargebackAcceptance] = useState("Yes");
    const [serviceAcceptance, setServiceAcceptance] = useState("Yes");
    const componentRef = useRef(null);

    const handlePrint = useReactToPrint({
        contentRef: componentRef,
    });


    const getUserData = async () => { // for get the updated user data after company profile submission
        await fetch('https://api.boompay.in/get-user', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`,
            }
        });
        // const data = await response.json();
        // if (response.status === 200) {
        //     // console.log(data.user);
        //     setUserprofile(data.user);
        //     setActive(data.user.Completed_step);
        //     setLoading(false);
        // } else if (response.status === 401) {
        //     setLoading(false);
        //     console.log('Unauthorized access. Please log in again.');
        //     message.error('Unauthorized access. Please log in again.');
        // } else if (response.status === 404) {
        //     setLoading(false);
        //     console.log('User not found.');
        //     message.error('User not found.');
        // } else {
        //     setLoading(false);
        //     console.log('An error occurred while fetching user data.');
        //     message.error('An error occurred while fetching user data.');
        // }
    }

    const handelSubmit = async () => {
        if (!commercialDate) {
            message.error('Please enter the commercial date before submitting the form.');
            return;
        }
        if (!payoutUseCase) {
            message.error('Please enter the purpose/use case of payout before submitting the form.');
            return;
        }
        if (chargebackAcceptance !== 'Yes' && serviceAcceptance !== 'Yes') {
            message.error('Please accept the chargeback and service acceptance terms before submitting the form.');
            return;
        }

        setSubmitloading(true);
        try {
            const response = await fetch('https://api.boompay.in/submit-payout-commercial-offer-letter', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                },
                body: JSON.stringify({
                    Registered_Name_of_Company: companyProfile?.Company_name || "",
                    Registered_GST_Number: companyProfile?.Company_GST_number || "",
                    Commercial_Date: commercialDate,
                    One_time_Implementation_Charges: totalImplementationCharge || 0,
                    Selected_Services: companyProfile?.Services_opted?.map(service => {

                        const matchedService = Servicespricecost.find(
                            item => item.service_name === service
                        );

                        return {
                            Service_name: service,
                            One_time_implementation_charge:
                                Number(matchedService?.One_time_implementation_charge || 0)
                        };

                    }),
                    Authorised_Signatory: companyProfile?.Directors?.filter(d => d.Is_Authroized_signatory).map(d => ({
                        Authorised_name: d.Director_name,
                        Authorised_mobile_number: d.Director_mobile_number,
                        Authorised_email: d.Director_email,
                        Authorised_DIN_number: d.Director_DIN_number,
                        Authorised_Share_perecentage: d.Share_perecentage,
                    })) || [],
                    Purpose_Use_Case_of_Payout: payoutUseCase,
                    Chargeback_Acceptance: chargebackAcceptance,
                    Service_Acceptance: serviceAcceptance,
                    Merchant_criminal_undertaking_schema_id: merchantcriminalundertaking?._id,
                    Board_of_resolution_schema_id: boardresolution?._id,
                    Bank_details_schema_id: banksdetails?._id,
                    Merchant_due_deligence_schema_id: merchantduedeligencedetails?._id,
                    Company_profile_schema_id: companyProfile._id,
                    Compliance_and_MAF_schema_id: compliancedetails._id,
                    Completed_step: 8, // Update the Completed_step to 8 after submitting payout commercial leter
                }),
            });
            const data = await response.json();
            if (response.status === 201) {
                //console.log(data.message);
                getUserData();
                setSubmitloading(false);
                message.success(data.message);
            } else if (response.status === 401) {
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
                setSubmitloading(false);
            } else {
                console.log('An error occurred while submitting bank details.');
                message.error('An error occurred while submitting bank details.');
                setSubmitloading(false);
            }
        } catch (error) {
            console.error('Error:', error);
            message.error('An unexpected error occurred. Please try again later.');
            setSubmitloading(false);
        }
    }

    const handleRectificationSubmit = async () => {
        if (!commercialDate) {
            message.error('Please enter the commercial date before submitting the form.');
            return;
        }
        if (!payoutUseCase) {
            message.error('Please enter the purpose/use case of payout before submitting the form.');
            return;
        }
        if (chargebackAcceptance !== 'Yes' && serviceAcceptance !== 'Yes') {
            message.error('Please accept the chargeback and service acceptance terms before submitting the form.');
            return;
        }
        setSubmitloading(true);
        try {
            const response = await fetch('https://api.boompay.in/put/rectify/payout-commercial-letter', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                },
                body: JSON.stringify({
                    Registered_Name_of_Company: companyProfile?.Company_name || "",
                    Registered_GST_Number: companyProfile?.Company_GST_number || "",
                    Commercial_Date: commercialDate,
                    One_time_Implementation_Charges: totalImplementationCharge || 0,
                    Selected_Services: companyProfile?.Services_opted?.map(service => {

                        const matchedService = Servicespricecost.find(
                            item => item.service_name === service
                        );

                        return {
                            Service_name: service,
                            One_time_implementation_charge:
                                Number(matchedService?.One_time_implementation_charge || 0)
                        };

                    }),
                    Authorised_Signatory: companyProfile?.Directors?.filter(d => d.Is_Authroized_signatory).map(d => ({
                        Authorised_name: d.Director_name,
                        Authorised_mobile_number: d.Director_mobile_number,
                        Authorised_email: d.Director_email,
                        Authorised_DIN_number: d.Director_DIN_number,
                        Authorised_Share_perecentage: d.Share_perecentage,
                    })) || [],
                    Purpose_Use_Case_of_Payout: payoutUseCase,
                    Chargeback_Acceptance: chargebackAcceptance,
                    Service_Acceptance: serviceAcceptance,
                    Company_profile_schema_id: submissionDetails?.Company_profile_schema_id
                })
            });
            const data = await response.json();
            if (response.status === 201) {
                //console.log(data.message);
                message.success(data?.message)
                onSuccess(); // Refresh user data to update.
                setSubmitloading(false);
            } else if (response.status === 400) {
                message.error(data.message);
                console.log(data.message);
            } else if (response.status === 401) {
                message.error('Unauthorized access. Please log in again.');
                console.log('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                message.error('User not found.');
                console.log('User not found.');
            } else {
                message.error('An error occurred while submitting company profile.');
                console.log('An error occurred while submitting company profile.');
            }
        } catch (error) {
            message.error('An error occurred while submitting company profile.');
            console.error('Error:', error);
        }
        setSubmitloading(false);
    }

    useEffect(() => {
        const getCompanyProfile = async () => {
            const response = await fetch('https://api.boompay.in/get-company-profile', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                //console.log(data.Companyprofile);
                setCompanyProfile(data.Companyprofile);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Company profile not found.');
                message.error('Company profile not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getComplianceandmaf = async () => {
            const response = await fetch('https://api.boompay.in/get-compliance-details-and-maf', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Complianceandmafdetails);
                setCompliancedetails(data.Complianceandmafdetails);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Compliance details not found.');
                message.error('Compliance details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getbanksdetails = async () => {
            const response = await fetch('https://api.boompay.in/get-bank-details', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Banksdetails);
                setbanksdetails(data.Banksdetails);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Banks details not found.');
                message.error('Banks details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getmerchantduedeligence = async () => {
            const response = await fetch('https://api.boompay.in/get-merchant-due-deligence', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Banksdetails);
                setmerchantduedeligencedetails(data.Merchantduedeligence);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Merchant details not found.');
                message.error('Merchant details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getboardofresolution = async () => {
            const response = await fetch('https://api.boompay.in/get-board-of-resolution', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Banksdetails);
                setboardresolution(data.Boardresolution);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Merchant details not found.');
                message.error('Merchant details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getmerchantcriminalundertaking = async () => {
            const response = await fetch('https://api.boompay.in/get-merchant-criminal-undertaking', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Banksdetails);
                setmerchantcriminalundertaking(data.Merchantcriminalundertaking);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Merchant details not found.');
                message.error('Merchant details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }

        if (user) {
            getCompanyProfile();
            getComplianceandmaf();
            getbanksdetails();
            getmerchantduedeligence();
            getboardofresolution();
            getmerchantcriminalundertaking();
        }
    }, [user])
    // calculate total implementation charges
    const totalImplementationCharge = companyProfile?.Services_opted?.reduce((total, service) => {
            const matchedService = Servicespricecost.find(
                (item) => item.service_name === service
            );
            return total + (matchedService ? Number(matchedService.One_time_implementation_charge) : 0);
        },
        0
    );

    useEffect(() => {
        const getUserData = async () => {
            setSubmitloading(true);
            const response = await fetch('https://api.boompay.in/get-submitted-details-for-rectification', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            //console.log(data);

            if (response.status === 200) {
                const profile = data.RectificationDetails.Merchant_criminal_undertaking_schema_id;
                // Bank Details
                setCommercialDate(
                    profile.undertakingDate || ''
                );
                // Payout case
                setPayoutUseCase();
                // Charge back acceptance
                setChargebackAcceptance();
                // Service acceptance
                setServiceAcceptance();
                setSubmitloading(false);
            } else if (response.status === 401) {
                setSubmitloading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                setSubmitloading(false);
                console.log('User not found.');
                message.error('User not found.');
            } else {
                setSubmitloading(false);
                console.log('An error occurred while fetching user data.');
                message.error('An error occurred while fetching user data.');
            }
        }

        if (user && rectification) {
            getUserData();
        }
    }, [user, rectification])
    return (
        <>
            <Flex gap="medium" vertical>
                <Spin spinning={submitloading} size="large" description="Please wait...">
                    <Card title="Payout Commercial Offer Letter" style={{ "box-shadow": "rgba(0, 0, 0, 0.24) 0px 3px 8px", }}>
                        <Alert type="warning" title="Please fill in all the required details as instructed. After completing the form, download the document and upload the signed copy on the company letterhead, duly stamped and signed by the  authorized signatory." showIcon />
                        <Group mt={'xs'}>
                            <TextInput label="Company name" value={companyProfile?.Company_name || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company CIN number" value={companyProfile?.Company_CIN_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company PAN number" value={companyProfile?.Company_PAN_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="GST number" value={companyProfile?.Company_GST_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="MSME number" value={companyProfile?.Company_MSME_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company address" value={companyProfile?.Company_address || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company mobile number" value={companyProfile?.Company_Mobile_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company email id" value={companyProfile?.Company_email || ""} disabled radius="xs" size="md" />
                        </Group>
                        <Divider label="Payout Commercial Offer Letter" my="sm" variant="dashed" labelPosition="center" />
                        <Paper
                            withBorder
                            shadow="xs"
                            p="xl"
                            radius="md"
                            style={{
                                backgroundColor: "#fff",
                                fontFamily: "Times New Roman",
                                lineHeight: "30px",
                                color: "#000",
                            }}
                            ref={componentRef}
                        >

                            <Stack gap="lg">

                                <Group justify="space-between">

                                    <Text fw={600}>
                                        To
                                    </Text>

                                    <Group gap={5}>
                                        <Text fw={600}>
                                            Date:
                                        </Text>

                                        <TextInput
                                            variant="unstyled"
                                            placeholder="Enter Date"
                                            value={commercialDate}
                                            onChange={(e) => setCommercialDate(e.target.value)}
                                            styles={{
                                                input: {
                                                    borderBottom: "1px solid black",
                                                    borderRadius: 0,
                                                    minWidth: "150px",
                                                    textAlign: "center",
                                                }
                                            }}
                                        />
                                    </Group>

                                </Group>

                                <Stack gap={1}>
                                    <Text fw={700}>
                                        BOOM PAY TECHNOLOGY PRIVATE LIMITED.
                                    </Text>

                                    <Text>
                                        Block- C Street No. 22, Khajoori Khas New Delhi- 110094
                                    </Text>
                                </Stack>

                                <Text fw={700}>
                                    Subject: Commercial Offer Letter (API)
                                </Text>

                                <Text>
                                    Dear Sir,
                                </Text>

                                <Text ta="justify">
                                    As discussed, please find below a commercial offer letter
                                    mutually agreed for Payout API.
                                </Text>

                                <Text size="sm">
                                    *GST as applicable
                                </Text>

                                {/* COMMERCIAL TABLE */}

                                <Table
                                    withTableBorder
                                    withColumnBorders
                                    striped
                                >
                                    <Table.Thead>

                                        <Table.Tr>
                                            <Table.Th>
                                                Payment API (Single / Multi)
                                            </Table.Th>

                                            <Table.Th>
                                                Rate per payment transaction
                                            </Table.Th>
                                        </Table.Tr>

                                    </Table.Thead>

                                    <Table.Tbody>

                                        <Table.Tr>
                                            <Table.Td>NEFT</Table.Td>
                                            <Table.Td>Rs. NA</Table.Td>
                                        </Table.Tr>

                                        <Table.Tr>
                                            <Table.Td>RTGS</Table.Td>
                                            <Table.Td>Rs. NA</Table.Td>
                                        </Table.Tr>

                                        <Table.Tr>
                                            <Table.Td>IMPS &lt; 1000</Table.Td>
                                            <Table.Td>Rs. 4</Table.Td>
                                        </Table.Tr>

                                        <Table.Tr>
                                            <Table.Td>IMPS &gt; 1000 and &lt; 25000</Table.Td>
                                            <Table.Td>Rs. 8</Table.Td>
                                        </Table.Tr>

                                        <Table.Tr>
                                            <Table.Td>IMPS &gt; 25000 to &lt; 100000</Table.Td>
                                            <Table.Td>Rs. 14</Table.Td>
                                        </Table.Tr>

                                        <Table.Tr>
                                            <Table.Td>IMPS 100000 and above</Table.Td>
                                            <Table.Td>(contact to admin)</Table.Td>
                                        </Table.Tr>

                                    </Table.Tbody>

                                </Table>
                                <Group align="center">

                                    <Text fw={600}>
                                        One-time Implementation Charges:
                                    </Text>

                                    <Text fw={700}>
                                        ₹ {totalImplementationCharge?.toLocaleString("en-IN")}
                                    </Text>

                                </Group>
                                {/* <Group align="center">

                                    <Text fw={600}>
                                        One-time Implementation Charges:
                                    </Text>

                                    <TextInput
                                        variant="unstyled"
                                        placeholder="Enter Charges"
                                        value={implementationCharge}
                                        onChange={(e) => setImplementationCharge(e.target.value)}
                                        styles={{
                                            input: {
                                                borderBottom: "1px solid black",
                                                borderRadius: 0,
                                                minWidth: "120px",
                                                textAlign: "center",
                                            }
                                        }}
                                    />

                                </Group> */}

                                {/* <Text>
                                    <strong>Monthly Transaction charges*:</strong> NA
                                </Text> */}

                                <Stack gap={3}>

                                    <Text fw={700}>
                                        Purpose / Use Case of Payout
                                    </Text>

                                    <Textarea
                                        autosize
                                        minRows={3}
                                        placeholder="Enter payout use case"
                                        value={payoutUseCase}
                                        onChange={(e) => setPayoutUseCase(e.target.value)}
                                    />

                                </Stack>

                                {/* CORPORATE DETAILS */}

                                <Title order={5} >
                                    CORPORATE DETAILS
                                </Title>

                                <Table
                                    withTableBorder
                                    withColumnBorders
                                >

                                    <Table.Tbody>

                                        <Table.Tr>
                                            <Table.Td fw={600}>
                                                Corporate Name
                                            </Table.Td>

                                            <Table.Td>
                                                {companyProfile?.Company_name}
                                            </Table.Td>
                                        </Table.Tr>

                                        <Table.Tr>
                                            <Table.Td fw={600}>
                                                Minimum Balance in Wallet in lakhs
                                            </Table.Td>

                                            <Table.Td>
                                                5 lakhs
                                            </Table.Td>
                                        </Table.Tr>

                                        <Table.Tr>
                                            <Table.Td fw={600}>
                                                Parking Amount / Deposit Amount
                                            </Table.Td>

                                            <Table.Td>
                                                5 lakhs
                                            </Table.Td>
                                        </Table.Tr>

                                        <Table.Tr>
                                            <Table.Td fw={600}>
                                                GSTN number
                                            </Table.Td>

                                            <Table.Td>
                                                {companyProfile?.Company_GST_number}
                                            </Table.Td>
                                        </Table.Tr>

                                        <Table.Tr>

                                            <Table.Td fw={600}>
                                                Chargeback or Penalty or Blockage of amount by bank
                                                or any charge related to it, if any will be borne by
                                                corporate and wallet will be freezed.
                                            </Table.Td>

                                            <Table.Td>

                                                <Select
                                                    data={["Yes"]}
                                                    value={chargebackAcceptance}
                                                    onChange={setChargebackAcceptance}
                                                />

                                            </Table.Td>

                                        </Table.Tr>

                                        <Table.Tr>

                                            <Table.Td fw={600}>
                                                Please note this service can't be used for DMT or
                                                Gaming platform or anything not mentioned in use case.
                                                Any complaint to be resolved at the merchant end and
                                                to bear all expenses related to it.
                                            </Table.Td>

                                            <Table.Td>

                                                <Select
                                                    data={["Yes"]}
                                                    value={serviceAcceptance}
                                                    onChange={setServiceAcceptance}
                                                />

                                            </Table.Td>

                                        </Table.Tr>
                                        <Table.Tr>

                                            <Table.Td fw={600}>
                                                Authorized signatory with stamp
                                            </Table.Td>

                                            <Table.Td>
                                                <TextInput
                                                    // variant="unstyled"
                                                    placeholder="Enter Name of Authorized Signatory"
                                                    value={companyProfile?.Directors?.find(d => d.Is_Authroized_signatory)?.Director_name || ""}
                                                    disabled
                                                />
                                            </Table.Td>

                                        </Table.Tr>

                                    </Table.Tbody>

                                </Table>

                            </Stack>

                        </Paper>


                        <Group justify="end">
                            <Button mt={'md'} size="lg" color="teal" variant="light" onClick={handlePrint}>Print Payout Commercial Offer Letter </Button>
                            {/* <Button mt={'md'} size="lg" color="lime" variant="light" onClick={handelSubmit} loading={submitloading}>Save changes</Button> */}
                            <Button
                                mt={'md'}
                                size="lg"
                                color="lime"
                                variant="light"
                                loading={submitloading}
                                onClick={
                                    rectification
                                        ? handleRectificationSubmit
                                        : handelSubmit
                                }
                            >
                                {
                                    rectification
                                        ? "Submit Rectification"
                                        : "Save Changes"
                                }
                            </Button>
                        </Group>

                    </Card>
                </Spin>
            </Flex>

        </>
    )
}
export default Payoutcommercial